module.exports = __webpack_public_path__ + "static/media/festival.9065637f.png";